module.exports = __webpack_public_path__ + "img/forte2.f664a63f.jpeg";